export const SELECTED_PRODUCT = "SELECTED_PRODUCT"
export const MIN_COUNT = "MIN_COUNT"
export const SELECTED_GROUP = "SELECTED_GROUP"
export const REMOVE_SELECTED = "REMOVE_SELECTED"
export const PRODUCT_ARRY = "PRODUCT_ARRY"
